import { Environment } from './env';

/**
 * Development Environment.
 * 
 * This file can be replaced during build by using the `fileReplacements` array.
 * 
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * `ng build --configuration=staging` replaces `environment.ts` with `environment.staging.ts`.
 * 
 * The list of file replacements can be found in `angular.json`.
 * 
 */
export const environment : Environment = {
  production: false,
  name: "DEVELOPMENT",
  baseHref: '/',
  enableAuth: false,
  envFilter: "dev",
  censusKey: "d9842d679b3e64d0f91ced27cdef9af67c86bf52"
};